import printNumber from './printNumber';

export default function formatFontVersion(versionNumber: number): string {
    return printNumber(versionNumber, 3);
}
